import React, { useEffect, useState } from "react"
import { convertRespArrToLabelObject, getDynamicLabel, handleError } from "../../utils/helpers"
import { changeCreateOrderTranslationValue } from "../../store/slices/TranslationSlice.ts"
import { getTranslationWithPageName } from "../../services/ApiServices"
import WithoutMeeting from "./WithoutMeeting/WithoutMeeting"
import { useDispatch, useSelector } from "react-redux"
import { PAGE_NAME } from "../../utils/pageName.ts"
import WithMeeting from "./WithMeeting/WithMeeting"
import "react-tooltip/dist/react-tooltip.css"
import Loader from "../Loader/Loader.js"
import { appName } from "../../const"
import "./CreateOrder.scss"

export default function CreateOrder() {
  const CreateOrderTranslation = useSelector((state) => state.Translation.CreateOrderTranslation)
  const [isWithMeeting, setIsWithMeeting] = useState(true)
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    setIsLoading(true)
    getTranslationWithPageName(PAGE_NAME?.CREATE_ORDER, appName).then((response) => {
      if (typeof response === "object" && response?.length >= 0) {
        dispatch(changeCreateOrderTranslationValue(convertRespArrToLabelObject(response)))
      } else {
        handleError(response)
      }
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])

  return (
    <>
      {isLoading && <Loader />}

      <div className="pagetitle d-flex mb-4">
        <h1 className="me-5 d-flex align-items-center">
          {getDynamicLabel(CreateOrderTranslation?.lblHeadCreateOrder, "Create Order")}
        </h1>
        <div
          className={`btn toggle-btn px-2 py-1 me-3 ${isWithMeeting ? "active" : ""}`}
          onClick={() => setIsWithMeeting(true)}
        >
          {getDynamicLabel(CreateOrderTranslation?.lblWithMeeting, "With Meeting")}
        </div>
        <div
          className={`btn toggle-btn px-2 py-1 ${isWithMeeting ? "" : "active"}`}
          onClick={() => setIsWithMeeting(false)}
        >
          {getDynamicLabel(CreateOrderTranslation?.lblWithoutMeeting, "Without Meeting")}
        </div>
      </div>
      <div>
        {isWithMeeting ? <WithMeeting /> : <WithoutMeeting />}
      </div>
    </>
  )
}
